import { createContext } from 'react';

const FormServerErrorsContext = createContext({});

export default FormServerErrorsContext;
